export default __webpack_public_path__ + "static/media/news (1).bd001e4e.webp";